<template>
    <div class="techFeatList">        
        <div class="techFeatCols" 
            v-html="replaceSuperscripts(componentData.content)"></div>
            <!-- componentData={{componentData}} -->
    </div> 
</template>

<style>
    .techFeatList
    {
        text-align: left;
        height: 100%;
        padding: 2vw 3vw;
        width: 800px;
        text-align: center;
        margin-left: auto;
        margin-right: auto; 
        /* border: solid 2px red; */
    }
    .techFeatList > *
    {
        text-align: left;
    }
    .techFeatCols > ol,
    .techFeatCols > ul
    {
        list-style: none;
        column-count: 2;
        list-style: none;
        column-gap: 20px;
    }
    .techFeatCols li{
        list-style: none;
        text-align: left;
        padding: 12px 0px;
        break-inside: avoid-column;

    }   


    .featuresBot ul
    {
        padding-top: 30px;
        list-style-type: decimal;
    } 
    .featuresBot ul li
    {
        text-align: left;
    } 
    .techFeatList sup
    {
        line-height: 0;
        font-size: 11px;
        font-weight: 300 !important;
    }
    .techFeatList .ck_content
    {
        font-size: 12px;
    }

    @media (max-width: 850px) { 
        .techFeatList
        {
            width: auto;
            padding: 0 10vw 10vw 10vw;
        }
    }

</style>

<script>
    import { mapActions, mapState } from "vuex";
    export default 
    {
        props: {
            componentData:Object
        },  
        data()
        {
            return {
                plaformIndex:-1,
            }
        },
        methods:{
            replaceSuperscripts(text) {
                //replace [[1]] = > <sup>1</sup>
                let temp =  text.replace(/\[\[(\d+)\]\]/g, '<sup>$1</sup>');
                //Add <BR> after Strong title
                temp = temp.replace(/<\/strong>/gi, '</strong><br/>');
                return temp;

            }
        }
    };
</script>